import { render, staticRenderFns } from "./Depts.vue?vue&type=template&id=b1f78a1a&scoped=true"
import script from "./Depts.vue?vue&type=script&lang=js"
export * from "./Depts.vue?vue&type=script&lang=js"
import style0 from "./Depts.vue?vue&type=style&index=0&id=b1f78a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f78a1a",
  null
  
)

export default component.exports